import { useFetchUserAvatar } from "../../../../../../hooks";
import "./index.css";

interface Props {
  loading?: boolean;
  width?: string;
  height?: string;
  rounded?: string;
}

export const UserAvatar: React.FC<Props> = ({
  loading = false,
  width = "4.3vh",
  height = "4.3vh",
  rounded = "2.1vh",
}) => {
  const { avatar: userAvatar, background, isLoading } = useFetchUserAvatar();

  return (
    <div
      className="min-w-[2.1vh] md:min-w-[4.3vh]"
      style={{ width: width, height: height }}
    >
      {userAvatar && !isLoading && !loading && (
        <div
          className=" flex justify-center items-center"
          style={{
            backgroundImage: background,
            width: width,
            height: height,
            borderRadius: rounded,
          }}
        >
          <img
            src={userAvatar}
            className=""
            style={{ width: width, height: height, borderRadius: rounded }}
            alt="user-avatar"
          />
        </div>
      )}
      {isLoading && <div className="loading"></div>}
      {loading && <div className="loading"></div>}
      {/* {!avatar && <div className="h-[36px] w-[36px] rounded-[18px] flex justify-center items-center" style={{backgroundImage:triggerAvatar.background}}>
    <img src = {triggerAvatar.avatar} className="w-8 h-8 rounded-[22.50px]"/>
    </div>

    } */}
    </div>
  );
};
